// ================================= GENERAL ================================ //
export interface Image {
    src: string
    alt: string
}

// =============================== COMPONENTS =============================== //
interface Components {
    header: Header;
    footer: Footer;
    whatsappApiLink: string;
    instagramLink: string;
    roomCard: RoomCard;
}

// HEADER
interface Header {
    mainLogo: MainLogo
    navbar: Navbar
}

// FOOTER
interface Footer {
    navbar: Navbar
    qr: Image
    mainLogo: MainLogo
    copyright: string
}

    interface MainLogo {
        image: Image;
        link: string
    }

// NAVBAR
interface Navbar {
    home: NavLink;
    rooms: NavLink;
    outside: NavLink;
    contact: NavLink;
    book: NavLink;
}

    interface NavLink {
        name: string;
        link: string;
    }

// ROOM CARD
interface RoomCard {
    moreInfoButton: string
    bookButton: string
}

// ================================= ROOMS ================================== //
export interface Room {
    name: string
    index: number
    icons: RoomIcons[]
    description: string[]
    images: RoomImages
}
    interface RoomIcons {
        icon: ERoomIcon | string
        text: string
    }
        export const enum ERoomIcon {
            BED = "bed",           // PAX
            SIZE = "size",         // Dimensiones
            WIFI = "wifi",         // Wi-Fi
            SAFEBOX = "safebox",   // Caja de seguridad
            MOUNTAIN = "mountain", // Vista al lago
            CITY = "city",         // Vista a la ciudad
            LAKE = "lake",         // Acceso al lago
            KITCHEN = "kitchen",   // Cocina
            WASHING = "washing",   // Lavarropas
            SHOWER = "shower",     // Baño con ducha
            SHUTTER = "shutter",   // Persiana de seguridad
            ROOM = "room"          // Ambientes/Habitaciones
        }

    interface RoomImages {
        cardImage: Image;
        roomImages: Image[];
        thumbnailsImages: Image[];
    }

// =============================== OUTSIDE ================================== //
interface Outside {
    name: string;
    index: number;
    images: OutsideImages
}

    interface OutsideImages {
        cardImage: Image;
        outsideImages: Image[]
    }

// ================================= PAGES ================================== //
interface Pages {
    homePage: HomePage;
    roomsPage: RoomsPage;
    outsidePage: OutsidePage;
    contactPage: ContactPage;
    bookPage: BookPage;
}

// HOME PAGE
interface HomePage {
    route: string;
    hero: Hero;
    presentation: PresentationSection;
    rooms: RoomsSection;
    outside: OutsideSection;
    location: LocationSection;
}
    interface Hero {
        fullLogo: Image;
        bookButton: BookButton;
        sliderImages: Image[]
    }

        interface BookButton {
            name: string;
            link: string;
        }

    interface PresentationSection {
        title: string
        subtitle: string
        paragraphs: string[]
    }

    interface RoomsSection {
        title: string
    }

    interface OutsideSection {
        title: string;
    }

    interface LocationSection {
        title: string
        iframeTitle: string
    }

// ROOMS PAGE
interface RoomsPage {
    route: string;
    bookButtonText: string;
}

// OUTSIDE PAGE
interface OutsidePage {
    route: string;
}

// CONTACT PAGE
interface ContactPage {
    route: string;
    headingTitle: string;
    contactForm: ContactForm;
    successAlert: ContactAlert;
    errorAlert: ContactAlert;
}

    interface ContactForm {
        nameInput: FormInput;
        emailInput: FormInput;
        messageInput: FormInput;
        submitButton: string;
    }

        interface FormInput {
            label: string;
        }

    interface ContactAlert {
        title: string;
        descriptions: string[]
    }

// BOOK PAGE
interface BookPage {
    route: string;
    externalUrl: string;
}

// ================================= APP ==================================== //
export interface IAppData {
    components: Components;
    pages: Pages;
    rooms: Room[];
    outside: Outside[];
}
